import { FileCheck2, ShieldCheck } from 'lucide-react';

export interface AppHeaderProps {
  readonly compact?: boolean;
}

export function AppHeader({ compact = false }: AppHeaderProps) {
  return (
    <header className="border-b border-slate-200 bg-white/95">
      <div className="mx-auto flex h-16 max-w-[1440px] items-center justify-between gap-4 px-4 sm:px-6 lg:px-8">
        <a
          href={import.meta.env.BASE_URL}
          className="group flex items-center gap-3 rounded-md outline-none focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-orange-600"
        >
          <span className="grid size-9 place-items-center rounded-lg bg-slate-800 text-white transition group-hover:bg-slate-700">
            <FileCheck2 aria-hidden="true" className="size-5" strokeWidth={1.8} />
          </span>
          <span className="min-w-0">
            <span className="block text-[15px] font-bold tracking-tight text-slate-900">
              BoQ Check <span className="text-slate-400">·</span> 清单体检
            </span>
            {!compact && (
              <span className="hidden text-xs text-slate-500 sm:block">
                工程量清单 Excel 交付前体检器
              </span>
            )}
          </span>
        </a>
        <div className="flex items-center gap-2 rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-xs font-semibold text-emerald-900">
          <ShieldCheck aria-hidden="true" className="size-4" strokeWidth={1.8} />
          <span className="hidden sm:inline">文件不会离开当前设备</span>
          <span className="sm:hidden">本机处理</span>
        </div>
      </div>
    </header>
  );
}
